// extracted by mini-css-extract-plugin
export default {"container":"QuestionDescription_container__pWyyH","text":"QuestionDescription_text__xmTDT"};